import type { CardinalityT } from '../../../../modernization-common/relationships';
import { CardinalityErrorContext } from './validation-utils';
export const CARDINALITY_DISPLAY: Record<CardinalityT, string> = {
  ONE_TO_ONE: '1:1',
  ONE_TO_MANY: '1:N',
  MANY_TO_ONE: 'N:1',
  MANY_TO_MANY: 'N:N'
};
export const CARDINALITY_ERROR_CONTEXT_DISPLAY: Record<CardinalityErrorContext, string> = {
  [CardinalityErrorContext.SOURCE]: 'source',
  [CardinalityErrorContext.TARGET]: 'target',
  [CardinalityErrorContext.SOURCE_TARGET]: 'source:target'
};